import { useCallback, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { notificationApiRef } from '../../../../../apis/notificationApi';
import { iqeAgentApiRef } from '../../../../../apis/iqeAgentApi';
import { toExecutionDashboard } from '../dto/responseDto/runResults.response.dto';
import type { IqeRunResultsRequest } from '../interfaces/api/requests/runResults.request';
import type { ExecutionDashboard } from '../interfaces/ui';

export const useExecutionResults = () => {
  const notificationApi = useApi(notificationApiRef);
  const iqeAgentApi = useApi(iqeAgentApiRef);
  const [data, setData] = useState<ExecutionDashboard | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const clearError = useCallback(() => setError(null), []);
  const reset = useCallback(() => {
    setData(null);
    setLoading(false);
    setError(null);
  }, []);

  const fetchResults = useCallback(
    async (request: IqeRunResultsRequest) => {
      setLoading(true);
      setError(null);
      try {
        const response = await iqeAgentApi.getIqeExecutionDashboard(request);
        setData(toExecutionDashboard(response));
      } catch (requestError) {
        const message = `Error: ${(requestError as Error).message}`;
        setError(message);
        notificationApi.sendNotification({
          message,
          disapperAfterMs: 4000,
          severity: 'error',
        });
      } finally {
        setLoading(false);
      }
    },
    [notificationApi, iqeAgentApi],
  );

  return { data, loading, error, clearError, reset, fetchResults };
};
